import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['selectedOption', 'option', 'options', 'hiddenInput', 'nextTarget'];
 
  connect() {
    document.addEventListener('click', this.handleOutsideClick.bind(this));
    this.setupFormValidation();
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick.bind(this));
  }

  selectOption({params}) {
    const selectedOptionText = event.target.textContent;
    this.selectedOptionTarget.textContent = selectedOptionText;
    this.hiddenInputTarget.value = params.value
    this.clearError();
    this.toggleOptions();
  }

  toggleOptions() {
    const optionsElement = this.optionsTarget;
    optionsElement.style.display = optionsElement.style.display === 'none' ? 'block' : 'none';
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.optionsTarget.style.display = 'none';
    }
  }
  clearError() {
    this.element.classList.remove('has-error');
  }

  showError() {
    this.element.classList.add('has-error');
  }
  setupFormValidation() {
    const form = this.element.closest('form');
    
    if(form && form.querySelector('#errors_not_selected')) 
      form.querySelector('#errors_not_selected').style.display = "none";
    
      // this.nextTarget.addEventListener('click', (event) => {
      //   const hiddenInput = form.querySelector('[data-custom-select-dropdown-target="hiddenInput"]');
      //   if (hiddenInput.value === '') {
      //     event.preventDefault();
      //     this.showError();
  
      //     const errorsDiv = form.querySelector('#errors_not_selected');
      //     errorsDiv.style.display = "block";
      //   }
      // });
  }
}